import React, { memo } from 'react';
import cc from 'classcat';
import type { NumberListType } from '../../../constants';
import { ROULETTE_NUMBERS, NUMBER_LIST_TYPE } from '../../../constants';

interface NumberItemProps {
  number?: number | null;
  type?: NumberListType | null;
  bonus?: string | null;
  border?: boolean;
  opaque?: boolean;
}

const rouletteClasses = (n: number, options: { border?: boolean; bonus?: string | null } = {}) =>
  cc([
    'number',
    ROULETTE_NUMBERS.RED.has(n) && 'number--red',
    ROULETTE_NUMBERS.BLACK.has(n) && 'number--black',
    n === 0 && 'number--green',
    options.border && 'number--whiteOutline',
    options.bonus && 'number--whiteOutline number--bonus'
  ]);

const blackjackClasses = (options: { border?: boolean; opaque?: boolean } = {}) =>
  cc([
    'number',
    'number--blackjack',
    options.opaque && 'number--opaque',
    options.border && 'number--whiteOutline'
  ]);

const uniformSquareClasses = (options: { border?: boolean; opaque?: boolean } = {}) =>
  cc([
    'number',
    'number--uniformSquare',
    options.border && 'number--whiteOutline',
    options.opaque && 'number--opaque'
  ]);

const NumberItem: React.FC<NumberItemProps> = ({
  number,
  type,
  border = false,
  opaque = false,
  bonus = null
}) => {
  if (!type) return null;

  const classes = cc([
    type === NUMBER_LIST_TYPE.ROULETTE && rouletteClasses(number ?? 0, { border, bonus }),
    type === NUMBER_LIST_TYPE.BLACKJACK && blackjackClasses({ opaque, border }),
    type === NUMBER_LIST_TYPE.UNIFORM_SQUARES && uniformSquareClasses({ opaque, border })
  ]);

  return (
    <div>
      <span className={classes}>{number}</span>
      {bonus && type === NUMBER_LIST_TYPE.ROULETTE && (
        <span className="number__bonusBadge">x{bonus}</span>
      )}
    </div>
  );
};

export default memo(NumberItem);
